export enum BookingSubStatusEnum {
  OK = 'OK',
  KO = 'KO',
  NO = 'NO',
}
